import axios from "../axiosInstance";
import {
  FetchTransactionListPeriodReportRequest,
  FetchTransactionListPeriodReportResponse,
} from "./types";

export const fetchQuickBooksTransactionListPeriodReport = async (
  requestData: FetchTransactionListPeriodReportRequest,
): Promise<FetchTransactionListPeriodReportResponse> => {
  const response = await axios.get<FetchTransactionListPeriodReportResponse>(
    "/api/private/quickbooks-transaction-list-period-report",
    {
      params: requestData,
    },
  );
  return response.data;
};
